import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Program } from './../../models/program/program';
import { Guide } from './../../models/guide/guide';
import { FieldManual } from './../../models/program/field-manual';
import { Edition } from '../../models/global/edition';

@Component({
  selector: 'app-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.less']
})
export class TileComponent implements OnInit {
  @Input() info: Guide | Program | FieldManual | Edition;
  @Input() tileType: string;
  @Input() fmOrder: number;
  @Output() settingsAction: EventEmitter<void> = new EventEmitter<void>();
  public showDialogue = false;

  constructor() { }

  ngOnInit(): void { };

  public settingsClicked(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.settingsAction.emit();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tile/tile.component.ts